function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocpredict(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 246.243 43.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo-Predict"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_797"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo-Approve"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9",
    d: "M43.5,25.9v13.9c0,2.1-1.7,3.8-3.8,3.8H3.8c-2.1-.1-3.8-1.8-3.8-3.9v-13.8H43.5Z",
    style: {
      fill: "#064b93"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_10",
    d: "M43.5,4.3V25.8H0V4.3C0,1.9,1.9,0,4.3,0H39.1c2.5,0,4.4,1.9,4.4,4.3h0Z",
    style: {
      fill: "#03968f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "AP"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.038,29.751c.433,0,.843,.082,1.229,.247,.385,.165,.721,.39,1.007,.676s.514,.622,.683,1.008,.253,.795,.253,1.229c0,.441-.084,.855-.253,1.241s-.396,.722-.683,1.008-.622,.511-1.007,.676c-.386,.165-.795,.247-1.229,.247h-2.366v2.756h-1.222v-9.087h3.588Zm0,5.135c.269,0,.52-.052,.754-.156,.234-.104,.439-.244,.617-.422s.316-.386,.416-.624,.15-.496,.15-.773c0-.269-.05-.522-.15-.761s-.238-.446-.416-.624-.383-.318-.617-.423c-.234-.104-.485-.155-.754-.155h-2.366v3.938h2.366Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.92,32.611c0,.363-.065,.708-.195,1.033-.13,.325-.306,.613-.527,.864-.221,.252-.483,.46-.787,.624-.303,.165-.628,.273-.975,.325l2.47,3.38h-1.521l-2.457-3.354h-1.547v3.354h-1.222v-9.1h3.887c.39,0,.76,.075,1.111,.228,.351,.151,.657,.357,.917,.617,.26,.26,.466,.565,.618,.916,.151,.352,.228,.722,.228,1.112Zm-2.873,1.677c.234,0,.451-.044,.65-.13,.199-.087,.373-.206,.52-.357,.147-.152,.262-.33,.345-.533,.082-.204,.124-.423,.124-.656s-.042-.453-.124-.657c-.083-.203-.197-.381-.345-.532-.147-.152-.321-.271-.52-.358-.199-.086-.416-.13-.65-.13h-2.665v3.354h2.665Z",
    style: {
      fill: "#fff"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11",
    d: "M.3,15.812L22.3,.312h6L.3,20.612s0-4.8,0-4.8Z",
    style: {
      fill: "#064b93"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_12",
    d: "M27.3,.712L.7,19.912v-3.9L22.5,.712h4.8M29.4,.012h-7.2L0,15.612v5.7L29.4,.012Z",
    style: {
      fill: "#03968f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_13",
    d: "M.3,6.812L9.5,.312h6.2L.3,11.512V6.812Z",
    style: {
      fill: "#064b93"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_14",
    d: "M14.6,.712L.7,10.812v-3.8L9.6,.712h5M16.8,.012h-7.4L0,6.612v5.5L16.8,.012Z",
    style: {
      fill: "#03968f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_23"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_15",
    d: "M38.5,9.659l-1.8,5.7-1.1-1.4-.6,.5-9.1,7.2-.1-.1-3.6-4.1-.6,.4-10,7-.4-.6-1.5-2-.6,.4-4.1,3H0v-.8l10.4-7.2h0l1.7,2.2,.4,.5,10.7-7.5,2.9,3.6,.4,.4h0l7.3-5.2-1.4-1.8h0l6.1-.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16",
    d: "M32.5,9.559h-.5l.3,.5h0l1.1,1.4-6.9,5-3.2-4-10.8,7.5-1.9-2.5-.1-.2L0,24.559v.6l10.4-7.2,2.1,2.7,10.7-7.5,3.2,4,7.7-5.5-1.2-1.6,5.3-.1-1.6,4.9-1-1.2-9.6,7.6-3.6-4.1-10.5,7.4-1.9-2.6-4.8,3.6H0v.5H5.2l4.5-3.3,1.9,2.6,10.5-7.4,3.4,3.9,.2,.2,9.7-7.6,1.2,1.6,2.1-6.4-6.2-.1Z",
    style: {
      fill: "#fff"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate",
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.876,33.999l-.033-16.83-8.349,14.025h-1.518l-8.349-13.927v16.731h-3.168V10.9h2.706l9.636,16.235,9.504-16.235h2.706l.033,23.1h-3.168Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.979,22.318h3.168v9.009c-1.145,.946-2.475,1.672-3.993,2.178s-3.102,.759-4.752,.759c-2.332,0-4.434-.511-6.303-1.534-1.87-1.023-3.338-2.431-4.405-4.224-1.067-1.793-1.601-3.812-1.601-6.056s.533-4.268,1.601-6.072c1.067-1.804,2.541-3.212,4.422-4.224s3.998-1.519,6.353-1.519c1.848,0,3.525,.303,5.033,.908,1.506,.604,2.788,1.49,3.844,2.656l-2.046,2.046c-1.848-1.782-4.081-2.673-6.699-2.673-1.76,0-3.338,.379-4.735,1.139-1.397,.759-2.492,1.814-3.284,3.168-.792,1.353-1.188,2.876-1.188,4.57,0,1.672,.396,3.185,1.188,4.537,.792,1.354,1.886,2.415,3.284,3.185,1.397,.771,2.964,1.155,4.703,1.155,2.067,0,3.872-.495,5.412-1.485v-7.523Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.449,10.9h3.3v23.1h-3.3V10.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.628,13.044c1.716,1.431,2.573,3.399,2.573,5.907s-.857,4.477-2.573,5.907c-1.717,1.43-4.07,2.145-7.062,2.145h-5.709v6.996h-3.3V10.9h9.009c2.992,0,5.346,.715,7.062,2.145Zm-2.376,9.752c1.1-.892,1.649-2.173,1.649-3.845s-.55-2.954-1.649-3.845c-1.101-.891-2.695-1.336-4.785-1.336h-5.61v10.361h5.61c2.09,0,3.685-.445,4.785-1.336Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.77,17.136c1.078-.527,2.387-.792,3.928-.792v3.069c-.177-.021-.419-.033-.727-.033-1.716,0-3.063,.512-4.042,1.534-.979,1.023-1.469,2.481-1.469,4.373v8.712h-3.168V16.509h3.036v2.938c.55-1.012,1.363-1.782,2.441-2.311Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.168,26.31h-14.19c.198,1.541,.875,2.778,2.029,3.713,1.155,.936,2.591,1.402,4.307,1.402,2.09,0,3.772-.703,5.049-2.111l1.749,2.046c-.792,.924-1.776,1.628-2.953,2.111-1.178,.484-2.491,.727-3.943,.727-1.849,0-3.487-.38-4.917-1.139-1.431-.759-2.536-1.82-3.316-3.185-.781-1.364-1.172-2.904-1.172-4.62,0-1.693,.38-3.223,1.139-4.587s1.804-2.426,3.135-3.185,2.832-1.139,4.505-1.139,3.162,.38,4.472,1.139c1.309,.759,2.331,1.82,3.068,3.185s1.105,2.926,1.105,4.686c0,.243-.022,.562-.065,.957Zm-12.392-5.906c-1.023,.924-1.623,2.134-1.799,3.63h11.22c-.176-1.474-.775-2.679-1.798-3.613-1.023-.936-2.294-1.403-3.812-1.403s-2.789,.463-3.812,1.387Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.123,9.513v24.486h-3.036v-2.772c-.704,.969-1.596,1.706-2.673,2.212-1.078,.506-2.267,.759-3.564,.759-1.694,0-3.212-.374-4.554-1.122s-2.393-1.799-3.151-3.151c-.759-1.354-1.139-2.909-1.139-4.67s.38-3.311,1.139-4.653c.759-1.341,1.81-2.387,3.151-3.135,1.342-.747,2.859-1.122,4.554-1.122,1.254,0,2.409,.237,3.465,.71,1.057,.474,1.937,1.171,2.641,2.096V9.513h3.168Zm-6.006,21.137c.901-.517,1.605-1.242,2.111-2.178,.506-.935,.76-2.008,.76-3.218s-.254-2.282-.76-3.218c-.506-.935-1.21-1.654-2.111-2.161-.902-.506-1.903-.759-3.003-.759-1.122,0-2.129,.253-3.02,.759-.892,.507-1.596,1.227-2.112,2.161-.518,.936-.775,2.008-.775,3.218s.258,2.283,.775,3.218c.517,.936,1.221,1.661,2.112,2.178,.891,.518,1.897,.775,3.02,.775,1.1,0,2.101-.258,3.003-.775Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.179,12.549c-.408-.396-.611-.88-.611-1.452s.203-1.061,.611-1.468c.406-.407,.918-.611,1.534-.611s1.127,.193,1.534,.578,.61,.863,.61,1.436c0,.594-.203,1.095-.61,1.501-.407,.407-.919,.61-1.534,.61s-1.128-.197-1.534-.594Zm-.05,3.96h3.168v17.49h-3.168V16.509Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.189,33.042c-1.397-.77-2.491-1.831-3.283-3.185-.792-1.353-1.188-2.888-1.188-4.604s.396-3.25,1.188-4.604c.792-1.353,1.886-2.409,3.283-3.168s2.987-1.139,4.769-1.139c1.584,0,2.998,.319,4.241,.957,1.242,.639,2.205,1.562,2.887,2.772l-2.408,1.551c-.551-.836-1.232-1.463-2.047-1.881-.813-.418-1.716-.627-2.706-.627-1.144,0-2.173,.253-3.085,.759-.913,.507-1.628,1.227-2.146,2.161-.517,.936-.775,2.008-.775,3.218,0,1.232,.259,2.315,.775,3.251,.518,.935,1.232,1.655,2.146,2.161,.912,.507,1.941,.759,3.085,.759,.99,0,1.893-.209,2.706-.627,.814-.418,1.496-1.045,2.047-1.881l2.408,1.518c-.682,1.211-1.645,2.141-2.887,2.789-1.243,.649-2.657,.974-4.241,.974-1.781,0-3.371-.385-4.769-1.155Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.243,32.976c-.462,.396-1.034,.699-1.716,.908-.683,.209-1.387,.313-2.112,.313-1.761,0-3.124-.473-4.092-1.419-.969-.946-1.452-2.299-1.452-4.06v-9.603h-2.97v-2.607h2.97v-3.828h3.168v3.828h5.016v2.607h-5.016v9.471c0,.946,.236,1.672,.709,2.178,.474,.507,1.149,.76,2.03,.76,.968,0,1.793-.275,2.475-.825l.99,2.276Z",
    style: {
      fill: "#fff"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocpredict);
export default __webpack_public_path__ + "static/media/docpredict.04578e46e7deb6fc8ef320b424806864.svg";
export { ForwardRef as ReactComponent };